import React from 'react';
import { Container, HStack, Box, Divider } from '@hover/blueprint';
import { Layout } from '../../components/common';
import { Hero, Content, Benefits, Form } from '../../components/job-posts';
import { IJobQuestion } from '../../interfaces/IJobQuestion';
import { IJobDemographicQuestions } from '../../interfaces/IJobDemographicQuestion';

interface IPropsJobDetails {
  pageContext: {
    id: string;
    title: string;
    description: string;
    office: string;
    department: string;
    allDetails: {
      questions: IJobQuestion[];
      demographic_questions: IJobDemographicQuestions;
    };
  };
}
const JobPosts: React.FC<IPropsJobDetails> = ({ pageContext }) => {
  const { title, description, office, department, allDetails, id } =
    pageContext;

  const { questions, demographic_questions: demographicQuestions } = allDetails;

  return (
    <Layout
      navbarBackgroundColor="brandTan.200"
      isNavbarWhite={false}
      titleColor="neutral.900"
      title={title}
      description="Please use PDF format for resumes.
    HOVER uses patented technology making it possible for anyone with a smartphone camera to create an interactive 3D model, complete with detailed measurements and powerful design features. The data produced is extremely valuable as it generates a single source of truth for the physical world allowing for more veracity throughout the home improvement and insurance processes. We’ve found an incredibly strong product-market fit across exterior home improvement, insurance, and financial services. What&#39;s the secret sauce? Cutting edge technology, an exceptional culture, and a commitment to our values (Think. Do. Serve.).&nbsp;
    With ..."
    >
      <Hero title={title} office={office} department={department} />
      <Container maxW="1248px" w="100%" px={500} centerContent>
        <HStack
          w="100%"
          spacing={{ base: 0, tablet: 1000, desktop: '134px' }}
          alignItems="flex-start"
        >
          <Box
            w="100%"
            maxW={{ base: '100%', tablet: '687px' }}
            flexDir="column"
          >
            <Content
              content={description}
              office={office}
              department={department}
            />
          </Box>
          <Box d={{ base: 'none', tablet: 'flex' }} maxW="379px">
            <Benefits />
          </Box>
        </HStack>
        <Divider
          borderColor="neutral.400"
          borderWidth={0}
          borderTopWidth="1px"
          mt={{ base: '20px', tablet: '60px' }}
          mb={700}
        />
        <Form
          id={id}
          title={title}
          office={office}
          department={department}
          questions={questions}
          demographicQuestions={demographicQuestions}
        />
      </Container>
    </Layout>
  );
};

export default JobPosts;
